import { ReactNode } from "react";
import styles from "./Container.module.scss";
import { useAppSelector } from "../../app/hooks";
import useMobileLayout from "../../hooks/useMobileLayout";

const Container = ({
  children,
  className,
  isButtonsInside,
}: {
  children: ReactNode;
  className?: string;
  isButtonsInside?: boolean;
}) => {
  const theme = useAppSelector((state) => state.activeTemplate.theme);
  const {
    container,
    cardButtonsInside,
    cryptoContainer,
    cryptoMobile,
    cryptoRemote,
  } = styles;
  const { isMobile, isCryptoOutsideApp } = useMobileLayout();

  return (
    <section
      className={`${container} ${isButtonsInside ? cardButtonsInside : ""} ${theme === "DIGITAL" ? cryptoContainer : ""} ${theme === "DIGITAL" && isMobile ? cryptoMobile : ""} ${isCryptoOutsideApp ? cryptoRemote : ""} ${className}`}
    >
      {children}
    </section>
  );
};

export default Container;
